// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filters-panel{min-height:300px}.base-panel-footer .base-button{-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:200px;padding-top:5px;padding-bottom:5px}", ""]);
// Exports
module.exports = exports;
